import { render } from "./HomeJoinUs.vue?vue&type=template&id=eff72280&scoped=true"
import script from "./HomeJoinUs.vue?vue&type=script&lang=js"
export * from "./HomeJoinUs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-eff72280"

export default script